import { Star } from 'lucide-react';
import React from 'react';

/**
 * Interactive 1-5 star selector. Click a star to set the rating; click the
 * current rating again to clear it back to unrated.
 */
interface StarRatingInputProps {
  label?: string;
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}

export const StarRatingInput = ({
  label = 'Star rating',
  value,
  onChange,
  disabled,
}: StarRatingInputProps): React.JSX.Element => (
  <div className="space-y-1.5">
    <span
      className={'text-sm leading-none font-medium text-zinc-900 ' + (disabled ? 'opacity-60' : '')}
    >
      {label}
    </span>
    <div className="flex h-10 items-center gap-1">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          disabled={disabled}
          onClick={() => onChange(n === value ? 0 : n)}
          aria-label={`${n} star${n === 1 ? '' : 's'}`}
          aria-pressed={n <= value}
          className="rounded p-0.5 transition-transform hover:scale-110 focus-visible:ring-2 focus-visible:ring-zinc-300 focus-visible:outline-none disabled:cursor-not-allowed"
        >
          <Star
            className={
              'h-5 w-5 transition-colors ' +
              (n <= value ? 'fill-amber-400 text-amber-400' : 'fill-zinc-100 text-zinc-300')
            }
            strokeWidth={1.5}
          />
        </button>
      ))}
      <span className="ml-2 text-xs text-zinc-500">
        {value > 0 ? `${value} star${value === 1 ? '' : 's'}` : 'Unrated'}
      </span>
    </div>
  </div>
);
